/*
* Created on Aug 10, 2020
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import axios from 'axios';
import qs from 'qs';
import { merge } from 'lodash';


export const AUTHAPI = {
    DEFAULT_CONFIG: {
        baseURL: `${process.env.REACT_APP_OAUTH_API_URL}/oauth`,
        timeout: 1000,
        headers: {'X-QNAP-APP-ID': ''}
    },
    get_access_token: async () => {
        const req_data = {
            client_id: process.env.REACT_APP_OAUTH_CLINET_ID,
            client_secret: process.env.REACT_APP_OAUTH_CLINET_ID,
            grant_type: ''
        }
        const custom_config = {
            method: 'POST',
            headers: {'content-type': 'application/x-www-form-urlencoded'},
            data: qs.stringify(req_data),
            url: 'token'
        }
        const { data } = await axios(merge(AUTHAPI.DEFAULT_CONFIG, custom_config));
        return data;
    },
    refresh_token: async () => {
        const custom_config = {
            method: 'POST',
            withCredentials: true,
            headers: {'content-type': 'application/x-www-form-urlencoded'},
            url: `${process.env.REACT_APP_ORGANIZATION_CENTER_DOMAIN}/ajax/refresh_token`
        }
        try {
            const { data } = await axios(custom_config);
            return data;
        } catch (err) {
            sessionStorage.removeItem('access_token');
            throw err;
        }
    },
    token_status: async (access_token) => {
        const { data } = await axios.get(`/tokeninfo?access_token=${access_token}`, (AUTHAPI.DEFAULT_CONFIG));
        return data;
    },
    user_info: async () => {
        const custom_config = {
            timeout: 1000,
            headers: {'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`}
        }
        const {data} = await axios.get(`${process.env.REACT_APP_OAUTH_API_URL}/v1.2/me`, custom_config);
        return data;
    },
    logout: () => {
        const url = `${process.env.REACT_APP_ACC_URL}/signout`;
        const params = {
            app_id: process.env.REACT_APP_OAUTH_CLINET_ID,
            redirect_uri: `${process.env.REACT_APP_ORGANIZATION_CENTER_DOMAIN}/receive_auth`
        }
        window.location = `${url}?${qs.stringify(params)}`;
    }
};

export class UserRolePermissions {
    constructor(permissions) {
        this.setPermissions(permissions);
    }

    setPermissions(permissions) {
        if (!permissions) {
            permissions = {};
        }
        this.role = permissions?.role || 'member';
        this.permissions = permissions.permissions || {};
    }

    hasPermission(requested_permission, target_resource_ids = null) {
        if (this.role === 'owner') return true;

        if (!Object.keys(this.permissions).includes(requested_permission)) return false;

        if (requested_permission === 'manage_site') {
            if (!target_resource_ids || target_resource_ids?.length <= 0) return false;
            const userSiteIds = new Set(this.permissions?.manage_site || []);
            return target_resource_ids.every(id => userSiteIds.has(id));
        }

        if (requested_permission === 'manage_device') {
            if (!target_resource_ids || target_resource_ids.length === 0) return false;

            const manageDevicePerms = this.permissions?.manage_device || {};

            // Combine device IDs from all possible sources within the permission object.
            const userDeviceIds = new Set([
                ...(manageDevicePerms.user_assigned || []),
                ...Object.values(manageDevicePerms.fixed || {}).flat()
            ]);

            // If manage_device is just a flat array, use it directly.
            if (Array.isArray(manageDevicePerms)) {
                manageDevicePerms.forEach(id => userDeviceIds.add(id));
            }

            return target_resource_ids.every(id => userDeviceIds.has(id));
        }

        return true;
    }

    hasAnyPermission(permission_name) {
        if (this.role === 'owner') return true;
        const perm = this.permissions?.[permission_name];
        if (!perm) return false;
        if (Array.isArray(perm)) return perm.length > 0;
        if (typeof perm === 'object') {
            const userAssigned = perm.user_assigned || [];
            const fixed = Object.values(perm.fixed || {}).flat();
            return (userAssigned.length + fixed.length) > 0;
        }
        return true;
    }

}